<div class="space-y-md">
  <div class="text-center plot-sm md:text-left">
    {{ heading() }}
  </div>
  <div
    class="flex flex-wrap justify-center gap-sm md:justify-start [&_cft-chip]:cursor-pointer [&_cft-chip:hover]:bg-grey-50"
  >
    <ng-content select="cft-chip"></ng-content>
  </div>
</div>
